module.exports = __webpack_public_path__ + "static/media/HS18.0024e9d5.png";